import logo from './logo.svg';
import {  Grid } from '@mui/material';
import './App.css';
import Home from './component/Home'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Academics from './component/academics/Academics';
import Commerce from './component/commerce/Commerce';
import Arts from './component/arts/Arts';
import Admission1 from './component/admissions/Admission1';

function App() {
  return (
    <Grid sx={{ overflowX: 'hidden', }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path='/science-page' element={<Academics/>} />
          <Route path='/commerce-page' element={<Commerce/>} />
          <Route path='/arts-page' element={<Arts/>} />
          <Route path='/admission-page' element={<Admission1/>} />
</Routes>
</BrowserRouter>
    </Grid>
  );
}

export default App;
